import { computed, onMounted, ref, watch } from 'vue'

import { logDesync } from '@backmarket/nuxt-layer-recommendation/helpers.ts'

import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

export function useLogDesync() {
  const { data: productResponse, status: productResponseStatus } =
    useFetchProduct()
  const {
    isOutOfStock,
    selectedOffer,
    status: pickersResponseStatus,
  } = useFetchPickers()

  const hasFinishFetching = computed(
    () =>
      pickersResponseStatus.value === 'success' &&
      productResponseStatus.value === 'success' &&
      productResponse.value?.productId,
  )

  const isMounted = ref(false)

  const stopWatch = watch([hasFinishFetching, isMounted], () => {
    // We want to trigger this logAsync only client side and once per product detail page.
    if (isMounted.value && hasFinishFetching.value) {
      logDesync({
        id: productResponse.value?.productId ?? '',
        isOutOfStock: isOutOfStock.value,
        price: selectedOffer.value?.price?.amount,
      })
      stopWatch()
    }
  })

  onMounted(() => {
    isMounted.value = true
  })
}
